import { useTheme } from 'context/ThemeContext'
import { Layer, Source } from 'react-map-gl'
import { useSelector } from 'react-redux'
import { selectGeoTiffLayer } from 'store/selectors/mission'

const GeoTiffLayer = ({ show }: { show: boolean }) => {
  const geoTiffLayer = useSelector(selectGeoTiffLayer)
  const { theme } = useTheme()

  if (!geoTiffLayer.layer || !geoTiffLayer.layer.urlTiles) return null

  let tilesBaseUrl = geoTiffLayer.layer.urlTiles
  // Rewrite nginx internal URL to the browser-accessible host
  if (tilesBaseUrl.includes('//nginx/') || tilesBaseUrl.includes('//nginx:')) {
    tilesBaseUrl = tilesBaseUrl.replace(/\/\/nginx[:/]/, `//${window.location.host}/`)
    const currentProtocol = window.location.protocol
    tilesBaseUrl = tilesBaseUrl.replace(/^https?:/, currentProtocol)
  } else if (!tilesBaseUrl.startsWith('http')) {
    const prefix = tilesBaseUrl.startsWith('/') ? '' : '/storage/'
    tilesBaseUrl = `${window.location.origin}${prefix}${tilesBaseUrl}`
  }

  let searchParams = ''
  try {
    const urlObj = new URL(tilesBaseUrl)
    searchParams = urlObj.search
    urlObj.search = ''
    tilesBaseUrl = urlObj.toString()
  } catch (e) {
    const queryIndex = tilesBaseUrl.indexOf('?')
    if (queryIndex !== -1) {
      searchParams = tilesBaseUrl.slice(queryIndex)
      tilesBaseUrl = tilesBaseUrl.slice(0, queryIndex)
    }
  }

  if (!tilesBaseUrl.endsWith('/')) {
    tilesBaseUrl += '/'
  }

  const tilesUrl = `${tilesBaseUrl}{z}/{x}/{y}.png${searchParams}`

  return (
    <Source key={tilesUrl} id="geo-tiff" type="raster" scheme="tms" tiles={[tilesUrl]} tileSize={256}>
      <Layer
        id="geo-tiff-layer"
        source="geo-tiff"
        type="raster"
        layout={{ visibility: show ? 'visible' : 'none' }}
        paint={
          {
            'raster-opacity': 1.0,
            'raster-fade-duration': 0,
            'raster-color': [
              'interpolate',
              ['linear'],
              ['raster-value'],
              0,
              theme === 'dark' ? '#00ff00' : '#ff00c8',
              255,
              'rgba(255, 255, 255, 0)',
            ],
            'raster-color-range': [0, 255],
          } as any
        }
      />
    </Source>
  )
}

export default GeoTiffLayer
